
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';
import { UserProfilesSearchQueryResponse } from '@models/user-profiles.model'

/**
 * Service for fetching customer data from the backend API.
 */
@Injectable({
  providedIn: 'root'
})
export class CustomerService {
  /**
   * Constructs the CustomerService with HttpClient injection.
   * 
   * @param http Angular HttpClient for making HTTP requests
   */
  constructor(private http: HttpClient) { }

  /**
   * Fetches a paginated list of customers from the API.
   * 
   * @param page The page number to fetch (default: 1)
   * @param limit The number of items per page (default: 10)
   * @param search_field search  (default: 10)
   * @returns Observable emitting the API response containing customer profiles
   */
  getCustomers(page: number = 1, limit: number = 10, search_field: string): Observable<UserProfilesSearchQueryResponse> {
    const token: string | null = localStorage.getItem('token');
    const headers: HttpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': ` ${token}`  // if needed
    });
    const fetchApi: string = `${environment.api_url}/user-profiles`;
    let params: HttpParams = new HttpParams()
      .set('page', page.toString())
      .set('limit', limit.toString());
    if (search_field) {
      params = params.set('search_field', search_field);
    }
    return this.http.get<UserProfilesSearchQueryResponse>(fetchApi, { params, headers });
  }

  /**
   * Fetches a paginated list of customers from the API.
   * 
   * @param user_id The unique identifier of the user_id whose details need to be fetched.
   * @returns Observable emitting the API response containing customer profiles
   */
  getCustomersByUserId(user_id: string): Observable<UserProfilesSearchQueryResponse> {
    const token: string | null = localStorage.getItem('token');
    const headers: HttpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': ` ${token}`  // if needed
    });

    const fetchApi: string = `${environment.api_url}/user-profiles/by-user-id`;
    const params: HttpParams = new HttpParams()
      .set('user_id', user_id)

    return this.http.get<UserProfilesSearchQueryResponse>(fetchApi, { params, headers });

  }
}
